import { Grid } from "react-styled-flexboxgrid";
import styled from "styled-components";
import { Color } from "../../theme/Color";

/**
 * For our app content we need different font color to public
 */
const StyledAppGrid = styled(Grid)<{
  bottomPadding?: Boolean;
}>`
  color: ${Color.Grey2};
  min-height: 100%;
  padding-bottom: ${({ bottomPadding }) => (bottomPadding ? "10rem" : "")};
`;

const AppGrid = (props) => {
  return (
    <StyledAppGrid
      bottomPadding={props.bottomPadding}
      className="app-grid"
      {...props}
    >
      {props.children}
    </StyledAppGrid>
  );
};

export default AppGrid;
